export default __webpack_public_path__ + "static/media/refreshPageIcon.28a2f1cb.svg";